import React from 'react';
import { DownloadIcon } from 'lucide-react';
import { download, generateCsv, mkConfig } from 'export-to-csv';
import { ActingDetailQueryResponse } from '@area-restrita/api-client/model/actingDetailQueryResponse';

import { Button } from '@/components/ui/button';

import { getBoardingPointsCsvRows } from './boardingPointsCsv';

interface IProps {
  acting: ActingDetailQueryResponse;
}

const ExportBoardingPointsButton: React.FC<IProps> = ({ acting }) => {
  const rows = getBoardingPointsCsvRows(acting.passengerEvents);

  const handleExport = () => {
    const config = mkConfig({
      filename: `pontos-de-embarque-${acting.id}`,
      fieldSeparator: ';',
      decimalSeparator: '.',
      useKeysAsHeaders: true,
      useBom: true,
    });

    download(config)(generateCsv(config)(rows));
  };

  return (
    <Button
      variant="outline"
      size="sm"
      disabled={!rows.length}
      onClick={handleExport}
    >
      <DownloadIcon className="mr-2 size-4" />
      Exportar embarques (CSV)
    </Button>
  );
};

export default ExportBoardingPointsButton;
